import { defineMessages } from 'react-intl';

export default defineMessages({
	submitButton: {
		id: 'paymentWithPaymentElement.submitButton',
		defaultMessage: 'Pay Now',
		description: 'Prompting the user to submit the payment.',
	},
	nameIsRequiredError: {
		id: 'paymentWithPaymentElement.errors.nameIsRequired',
		defaultMessage: 'Please enter the name on your card.',
		description: 'Prompting the user to add the name on their credit or debit card.',
	},
});
